export default __webpack_public_path__ + "static/media/Refer-a-friend-picture_955x660.599d3de5.jpg";